import { SAMPLE } from "./type";

const initialState = {
    sampleData: {},
  };

  const importReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
      case SAMPLE:
        return {
          ...state,
          sampleData: payload,
        };
      default:
        return { ...state };
    }
  };
  
  export default importReducer;
  
  